// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@melloware/coloris/dist/coloris.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}

#editor {
  width: 100%;
  height: 100vh;
  display: flex;
}
#editor #editor-main {
  width: calc(100% - 300px);
  background: #d5d8dc;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
#editor #editor-main #top-bar {
  height: 40px;
  width: 100%;
  background: #1f2124;
}
#editor #editor-main #top-bar #devices {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
#editor #editor-main #top-bar #devices > div {
  height: 100%;
  padding: 0 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
#editor #editor-main #top-bar #devices > div.selected {
  background: #3f444b;
}
#editor #editor-main #top-bar #devices > div svg {
  fill: #d5d8dc;
}
#editor #editor-main #frame {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  transition: all 0.3s;
  border: none;
}
#editor #editor-sidebar {
  width: 300px;
  padding: 10px;
  color: #d5d8dc;
  font-family: Arial;
  background: #1f2124;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
  position: relative;
}
#editor #editor-sidebar #components {
  transform: translateX(-400px);
  transition: transform 0.3s ease;
  position: absolute;
  padding-top: 30px;
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, 145px);
  gap: 10px;
  overflow-y: auto;
  user-select: none;
}
#editor #editor-sidebar #components.show {
  transform: translateX(0) !important;
}
#editor #editor-sidebar #components .block {
  border: 1px solid #3f444b;
  border-radius: 5px;
  height: 85px;
  cursor: grab;
  transition: all 0.3s;
}
#editor #editor-sidebar #components .block:hover {
  background-color: #2b2c31;
  border-color: #3f444b;
}
#editor #editor-sidebar #components .block > div {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 60px;
}
#editor #editor-sidebar #components .block svg {
  height: 28px;
  width: 28px;
  fill: currentColor;
}
#editor #editor-sidebar #components .block h3 {
  font-size: 12px;
  font-family: Roboto, sans-serif;
  margin: 0px;
  text-align: center;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#editor #editor-sidebar #style-manager {
  transform: translateX(400px);
  transition: transform 0.3s ease;
  width: 100%;
}
#editor #editor-sidebar #style-manager.show {
  transform: translateX(0) !important;
}
#editor #editor-sidebar #style-manager #back-icon {
  width: 28px;
  fill: currentColor;
  cursor: pointer;
}
#editor #editor-sidebar #style-manager #style-sectors {
  height: 94vh;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
#editor #editor-sidebar #style-manager #style-sectors::-webkit-scrollbar {
  width: 5px;
}
#editor #editor-sidebar #style-manager #style-sectors::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
#editor #editor-sidebar #style-manager #style-sectors::-webkit-scrollbar-thumb {
  background-color: #1f2124;
  outline: 1px solid slategrey;
  border-radius: 10px;
}
#editor #editor-sidebar #style-manager #style-sectors .details summary {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
  user-select: none;
  cursor: pointer;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div {
  padding: 0 15px 20px;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property label {
  text-wrap: nowrap;
  font-size: 12px;
  font-family: Roboto;
  font-weight: 500;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property input,
#editor #editor-sidebar #style-manager #style-sectors .details > div .property select {
  width: 143px;
  height: 19px;
  outline: none;
  border: 1px solid #4a4a6a;
  background: inherit;
  border-radius: 4px;
  color: #d5d8dc;
  font-size: 0.875rem;
  padding: 3px;
  text-align: center;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property input::placeholder,
#editor #editor-sidebar #style-manager #style-sectors .details > div .property select::placeholder {
  text-align: center;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property input[type=color] {
  padding: 2px;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property select {
  background: #1f2124;
  height: 27px;
  width: 150px;
  margin-left: 10px;
  text-align: left;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property .clr-field {
  width: 150px;
  margin-left: 10px;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property .clr-field button {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  right: 3px;
  top: 13px;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property .clr-field input {
  width: -webkit-fill-available;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property.multi-input-property {
  flex-direction: column;
  align-items: start !important;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property.multi-input-property .multi-input {
  height: 27px;
  width: 260px;
  display: flex;
  border-radius: 4px;
  border: 1px solid #4a4a6a;
  overflow: hidden;
  margin-top: 10px;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property.multi-input-property .multi-input input {
  width: 51px !important;
  border-radius: 0 !important;
  border: none !important;
  border-right: 1px solid #4a4a6a !important;
}
#editor #editor-sidebar #style-manager #style-sectors .details > div .property.multi-input-property .multi-input button.link-button {
  cursor: pointer;
  outline: none;
  border: none;
  color: white;
  background: #3f444b;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,aAAA;AAAF;AAEE;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAAJ;AAEI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAAN;AAEM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAR;AAEQ;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAAV;AAEU;EACE,mBAAA;AAAZ;AAGU;EACE,aAAA;AADZ;AAOI;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;AALN;AASE;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AASI;EACE,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AASM;EACE,mCAAA;AAPR;AAUM;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AARR;AAUQ;EACE,yBAAA;EACA,qBAAA;AARV;AAWQ;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AATV;AAYQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAVV;AAaQ;EACE,eAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAXV;AAgBI;EACE,4BAAA;EACA,+BAAA;EACA,WAAA;AAdN;AAgBM;EACE,mCAAA;AAdR;AAiBM;EACE,WAAA;EACA,kBAAA;EACA,eAAA;AAfR;AAkBM;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAhBR;AAkBQ;EACE,UAAA;AAhBV;AAmBQ;EACE,4CAAA;AAjBV;AAoBQ;EACE,yBAAA;EACA,4BAAA;EACA,mBAAA;AAlBV;AAsBU;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AApBZ;AAuBU;EACE,oBAAA;AArBZ;AAuBY;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AArBd;AAuBc;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AArBhB;AAwBc;;EAEE,YAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAtBhB;AAwBgB;;EACE,kBAAA;AArBlB;AAyBc;EACE,YAAA;AAvBhB;AA0Bc;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAxBhB;AA2Bc;EACE,YAAA;EACA,iBAAA;AAzBhB;AA4Bc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AA1BhB;AA6Bc;EACE,6BAAA;AA3BhB;AA8Bc;EACE,sBAAA;EACA,6BAAA;AA5BhB;AA8BgB;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AA5BlB;AA8BkB;EACE,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,0CAAA;AA5BpB;AA+BkB;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AA7BpB","sourcesContent":["@import \"../../node_modules/@melloware/coloris/dist/coloris.css\";\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n#editor {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n\n  #editor-main {\n    width: calc(100% - 300px);\n    background: #d5d8dc;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n\n    #top-bar {\n      height: 40px;\n      width: 100%;\n      background: #1f2124;\n\n      #devices {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n\n        & > div {\n          height: 100%;\n          padding: 0 5px;\n          display: flex;\n          align-items: center;\n          cursor: pointer;\n\n          &.selected {\n            background: #3f444b;\n          }\n\n          svg {\n            fill: #d5d8dc;\n          }\n        }\n      }\n    }\n\n    #frame {\n      height: 100%;\n      width: 100%;\n      margin: 0 auto;\n      background: #fff;\n      transition: all 0.3s;\n      border: none;\n    }\n  }\n\n  #editor-sidebar {\n    width: 300px;\n    padding: 10px;\n    color: #d5d8dc;\n    font-family: Arial;\n    background: #1f2124;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    overflow: hidden;\n    position: relative;\n\n    #components {\n      transform: translateX(-400px);\n      transition: transform 0.3s ease;\n      position: absolute;\n      padding-top: 30px;\n      width: 100%;\n      height: auto;\n      display: grid;\n      grid-template-columns: repeat(auto-fill, 145px);\n      gap: 10px;\n      overflow-y: auto;\n      user-select: none;\n\n      &.show {\n        transform: translateX(0) !important;\n      }\n\n      .block {\n        border: 1px solid #3f444b;\n        border-radius: 5px;\n        height: 85px;\n        cursor: grab;\n        transition: all 0.3s;\n\n        &:hover {\n          background-color: #2b2c31;\n          border-color: #3f444b;\n        }\n\n        & > div {\n          padding-top: 15px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-size: 60px;\n        }\n\n        svg {\n          height: 28px;\n          width: 28px;\n          fill: currentColor;\n        }\n\n        h3 {\n          font-size: 12px;\n          font-family: Roboto, sans-serif;\n          margin: 0px;\n          text-align: center;\n          height: 40px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n    }\n\n    #style-manager {\n      transform: translateX(400px);\n      transition: transform 0.3s ease;\n      width: 100%;\n\n      &.show {\n        transform: translateX(0) !important;\n      }\n\n      #back-icon {\n        width: 28px;\n        fill: currentColor;\n        cursor: pointer;\n      }\n\n      #style-sectors {\n        height: 94vh;\n        overflow: hidden;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column;\n        row-gap: 10px;\n\n        &::-webkit-scrollbar {\n          width: 5px;\n        }\n\n        &::-webkit-scrollbar-track {\n          box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background-color: #1f2124;\n          outline: 1px solid slategrey;\n          border-radius: 10px;\n        }\n\n        .details {\n          summary {\n            font-size: 14px;\n            font-weight: bold;\n            margin-bottom: 5px;\n            user-select: none;\n            cursor: pointer;\n          }\n\n          & > div {\n            padding: 0 15px 20px;\n\n            .property {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              margin-bottom: 10px;\n              flex-wrap: wrap;\n\n              label {\n                text-wrap: nowrap;\n                font-size: 12px;\n                font-family: Roboto;\n                font-weight: 500;\n              }\n\n              input,\n              select {\n                width: 143px;\n                height: 19px;\n                outline: none;\n                border: 1px solid #4a4a6a;\n                background: inherit;\n                border-radius: 4px;\n                color: #d5d8dc;\n                font-size: 0.875rem;\n                padding: 3px;\n                text-align: center;\n\n                &::placeholder {\n                  text-align: center;\n                }\n              }\n\n              input[type=\"color\"] {\n                padding: 2px;\n              }\n\n              select {\n                background: #1f2124;\n                height: 27px;\n                width: 150px;\n                margin-left: 10px;\n                text-align: left;\n              }\n\n              .clr-field {\n                width: 150px;\n                margin-left: 10px;\n              }\n\n              .clr-field button {\n                width: 20px;\n                height: 20px;\n                border-radius: 5px;\n                right: 3px;\n                top: 13px;\n              }\n\n              .clr-field input {\n                width: -webkit-fill-available;\n              }\n\n              &.multi-input-property {\n                flex-direction: column;\n                align-items: start !important;\n\n                .multi-input {\n                  height: 27px;\n                  width: 260px;\n                  display: flex;\n                  border-radius: 4px;\n                  border: 1px solid #4a4a6a;\n                  overflow: hidden;\n                  margin-top: 10px;\n\n                  input {\n                    width: 51px !important;\n                    border-radius: 0 !important;\n                    border: none !important;\n                    border-right: 1px solid #4a4a6a !important;\n                  }\n\n                  button.link-button {\n                    cursor: pointer;\n                    outline: none;\n                    border: none;\n                    color: white;\n                    background: #3f444b;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
